import { mdiSmoking, mdiSmokingOff } from "@mdi/js";

export const SMOKING_STATUS = {
  PREVIOUSLY: "Previously",
  NEVER: "Never",
  CURRENTLY: "Currently",
};

export type SmokingStatus =
  (typeof SMOKING_STATUS)[keyof typeof SMOKING_STATUS];

interface SmokingStatusItem {
  title: string;
  value: SmokingStatus;
  color: string;
  icon: string;
  dataTestid: string;
}

export const SMOKING_STATUSES: SmokingStatusItem[] = [
  {
    title: SMOKING_STATUS.NEVER,
    value: SMOKING_STATUS.NEVER,
    color: "success",
    icon: mdiSmokingOff,
    dataTestid: "smoker-never",
  },
  {
    title: SMOKING_STATUS.PREVIOUSLY,
    value: SMOKING_STATUS.PREVIOUSLY,
    color: "previously",
    icon: mdiSmokingOff,
    dataTestid: "smoker-previously",
  },
  {
    title: SMOKING_STATUS.CURRENTLY,
    value: SMOKING_STATUS.CURRENTLY,
    color: "error",
    icon: mdiSmoking,
    dataTestid: "smoker-currently",
  },
];

interface SmokingFrequencyItem {
  title: string;
  value: number;
}

export const SMOKING_FREQUENCIES: SmokingFrequencyItem[] = [
  {
    value: 365,
    title: "Daily",
  },
  {
    value: 52,
    title: "Weekly",
  },
  {
    value: 12,
    title: "Monthly",
  },
  {
    value: 2,
    title: "1-2 Times/Year",
  },
];

export const SMOKING_TYPE = {
  CANNABIS: "Cannabis",
  CHEW: "Chew",
  CIGARETTES: "Cigarettes",
  CIGARS: "Cigars",
  E_CIGARETTES: "eCigarettes",
  PIPE: "Pipe",
};

export type SmokingType = (typeof SMOKING_TYPE)[keyof typeof SMOKING_TYPE];

export const SMOKING_TYPES = Object.values(SMOKING_TYPE);

export const SINGULAR_TYPES = {
  [SMOKING_TYPE.CANNABIS]: "Cannabis",
  [SMOKING_TYPE.CHEW]: "Chew",
  [SMOKING_TYPE.CIGARETTES]: "Cigarette",
  [SMOKING_TYPE.CIGARS]: "Cigar",
  [SMOKING_TYPE.E_CIGARETTES]: "eCigarette",
  [SMOKING_TYPE.PIPE]: "Pipe",
};
